module.exports = __webpack_public_path__ + "img/lv2_1_1.a0b2004b.png";